import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener} 	from '@angular/core';




@Component({
        standalone: false,
  selector: 'uikit-donationdrive-modal',
  templateUrl: "./uikit.donationdrive.modal.html",
  styles : [
	`
		.donationdrive-modal-parent {
			position: absolute;
			left: 50%;
			z-index: 100;
			min-width : 50%;
			max-width : 90%;
		}
		.ui_modal.donationdrive-modal {
			position: relative;
			z-index: 101;
			max-width: 90%;
			left: -50%;
		}
		@media (max-width:767px) {
			.ui_modal.donationdrive-modal {
				max-width: 94%;
				margin-left: 3%;
			}
			.donationdrive-modal-parent {
				min-width : 85%;
			}
			.donationdrive-modal-parent .ui_modal .ui_modal_btns .ui_btn.ui_btn_primary {
				margin-top : 10px;
			}
		}
	`

  ]
})
export class UiKitDonationDriveModalComp implements OnInit , AfterViewInit  {

			
	@Output() change = new EventEmitter<string>();
	@Input() donationDrive = null;
	showing:boolean = false;
	initialized:boolean = false;
	tanzeel:any = window["DATA"];


    constructor(private _el: ElementRef){
    }

    ngOnInit(){
		this.initialized=true;
    }
		
	ngAfterViewInit() {
	}	

	action( val:string ){
		this.change.emit( val );
	}

	getImageUrl(){
		if( this.donationDrive != null && this.donationDrive.imageFile ){
			return this.tanzeel.tanzeelDocsCP + this.donationDrive.imageFile;
		}
		return null;
	}
}